// extracted by mini-css-extract-plugin
export default {"ErrorPage":"ErrorPage_ErrorPage__J5ye0","ErrorPageText":"ErrorPage_ErrorPageText__YYukg","theme-light":"ErrorPage_theme-light__rEplk","theme-dark":"ErrorPage_theme-dark__Sq2oN"};